import { BaseVO } from './BaseVO';
import { MediaPlanOptionVO } from './MediaPlanOptionVO';
import { NameValuePairVO } from './NameValuePairVO';
import { CreativeVO } from './CreativeVO';
import { MediaPlanVO } from './MediaPlanVO';

export class CampaignVO extends BaseVO {
    //indicates whether flight is
    flightId?: number;
    startDate: number;
    endDate: number;
    segment: NameValuePairVO;
    //A, M. F
    gender?: string;
    // 4-13, 4+, etc
    age?: string;
    //id for existing language/genre/channel setting
    constraintId?: string;
    //daypartConstraintId?: string;
    languages: Array<string>;
    genres: Array<string>;
    channels: Array<string>;
    excludeChannels?: Array<string>;
    excludeChannelsConstraintId?: string;
    budget: number;
    goalType?: string;
    goalObjectiveId?: number;
    autoSelect: boolean;
    creatives: Array<CreativeVO>;
    status: string;
    mediaPlanOption?: MediaPlanOptionVO;
    mediaPlan?: MediaPlanVO;
    audienceSize?: number;
    totalAudienceSize?: number;
    produceCreative?: Array<CreativeVO>;
    videoOptions?: Array<any>;
    videoLanguages?: Array<string>;
    skipCreative?: boolean;
    adDuration?: string;
    planId?: number;
    constructor() {
        super();
    }

}
